import { create } from "zustand";
import { Button, Card, Space, Modal, notification } from "antd";
import { PlusOutlined } from "@ant-design/icons";
import DataListStore from "store/DataListStore";
import ListViewV2 from "../DataListV2";
import { useEffect, useRef, useState } from "react";
import {
  ProForm,
  ProFormDigit,
  ProFormSelect,
  ProFormText,
} from "@ant-design/pro-components";
import { getRequest } from "services/EndPointApiService";
import { AddProductShopee } from "services/datalist/datalist-api";

const kodebarangStore = create(DataListStore);

async function requestProductShopee() {
  let data = await getRequest("DataList/GetProductShopee");
  return data.map((d) => ({
    value: d.KodeBarang,
    label: d.KodeBarang,
  }));
}

async function requestProductShopeeSummary() {
  let data = await getRequest("DataList/GetProductShopeeSummary");
  if (data.length > 0) {
    return data[0];
  }
  return { TotalBarang: 0, HargaTotal: 0 };
}

function WarehouseInventory(props) {
  const formRef = useRef();
  const [isModalOpen, setModalOpen] = useState(false);
  const [reloader, setReloader] = useState(false);

  const [summary, setSummary] = useState({ TotalBarang: 0, HargaTotal: 0 });

  const openModal = () => {
    setModalOpen(true);
  };

  const closeModal = () => {
    setModalOpen(false);
  };

  const onModalOK = () => {
    console.log(formRef);
    formRef.current.submit();
  };

  useEffect(() => {
    requestProductShopeeSummary().then((res) => {
      setSummary(res);
    });
  }, [reloader]);

  return (
    <Card
      title={
        <strong>
          <h1>Inventaris Barang</h1>
        </strong>
      }
    >
      <Button type="primary" onClick={openModal}>
        <Space>
          <PlusOutlined /> Tambahkan Barang
        </Space>
      </Button>
      <br />
      <br />
      <p>
        Total Barang :{" "}
        <b>{summary.TotalBarang?.toLocaleString("id") ?? 0} Pcs</b>
      </p>
      <p>
        Total Harga :{" "}
        <b> Rp. {summary.HargaTotal?.toLocaleString("id") ?? 0}</b>
      </p>

      <Modal
        title="Tambahkan Barang"
        open={isModalOpen}
        onOk={onModalOK}
        onCancel={closeModal}
      >
        <ProForm
          formRef={formRef}
          submitter={false}
          onFinish={async (val) => {
            console.log(val);
            await AddProductShopee(val).then(() => {
              notification.success({
                message: "Success",
              });
            });
            formRef.current.resetFields();
            closeModal();
            setReloader(!reloader);
          }}
        >
          <ProFormSelect
            showSearch
            name={"kode"}
            label={"Kode Barang (Sesuai Pesanan Shopee)"}
            request={requestProductShopee}
            placeholder={"Silahkan cek kodebarang yang tersedia disini."}
          />
          <ProFormText
            name={"kode"}
            label="Kode Barang (Input Manual)"
            rules={[{ required: true }]}
          />
          <ProFormText
            name={"nama"}
            label="Nama Barang"
            rules={[{ required: true }]}
          />
          <ProFormText
            name={"barcode"}
            label="Barcode Barang"
            rules={[{ required: true }]}
          />
          <ProFormDigit
            name={"jumlah"}
            label="Jumlah Barang"
            rules={[{ required: true }]}
          />
          <ProFormDigit
            name={"harga"}
            label="Harga Barang Satuan (Rupiah)"
            rules={[{ required: true }]}
          />
        </ProForm>
      </Modal>

      <ListViewV2
        viewId="shopeeinventory"
        store={kodebarangStore}
        hideTitle={true}
        reloader={reloader}
      />
    </Card>
  );
}

export default WarehouseInventory;
